import { Card, Col, Flex, Row, Typography } from "antd";
import React from "react";
import { Theme } from "../../../Dto/Theme.dto";

interface ThemeCardProps {
  theme: Theme;
  handleCardClick: () => void;
}

const gridStyle: React.CSSProperties = {
  textAlign: "center",
  borderRadius: "50%",
  width: "70px",
  height: "70px",
  overflow: "hidden",
  position: "relative",
  boxShadow: "none",
};

const cardStyle: React.CSSProperties = {
  padding: "16px",
  margin: "0",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "8px",
  transition: "all 0.3s ease",
};

const ThemeCard: React.FC<ThemeCardProps> = ({ theme, handleCardClick }) => {
  const { secondaryColor, primaryColor, tertiaryColor } = theme;

  return (
    <Card
      hoverable
      onClick={() => handleCardClick()}
      style={{
        ...cardStyle,
        cursor: "pointer",
      }}
      className="theme-card"
    >
      <Flex
        align="center"
        justify="center"
        vertical
        style={{ width: "100%" }}
        gap="8px"
      >
        <Card.Grid style={gridStyle}>
          <Row
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "50%",
              backgroundColor: secondaryColor,
            }}
          />
          <Row>
            <Col
              style={{
                position: "absolute",
                bottom: 0,
                left: 0,
                width: "50%",
                height: "50%",
                backgroundColor: primaryColor,
              }}
            />
            <Col
              style={{
                position: "absolute",
                bottom: 0,
                right: 0,
                width: "50%",
                height: "50%",
                backgroundColor: tertiaryColor,
              }}
            />
          </Row>
        </Card.Grid>
        <Typography.Title
          level={5}
          type="secondary"
          style={{
            textTransform: "capitalize",
            margin: 0,
          }}
        >
          {theme.themeName}
        </Typography.Title>
      </Flex>
    </Card>
  );
};

export default ThemeCard;
